import axios from 'axios'

import config from '@/config/config'
import retry from '@/utils/retry'
import { getServerDateTime, getLocalDateTime } from '@/utils/time'

// re-export
export * from '@/api/selfcheck'

export const instance = axios.create({
  baseURL: config.baseUrl,
  headers:
    process.env.VUE_APP_LANG === 'zh-cn'
      ? {
          'Language-Id': process.env.VUE_APP_LANG || 'ja',
          Authorization:
            process.env.VUE_APP_AC_APPCODE !== ''
              ? 'APPCODE ' + process.env.VUE_APP_AC_APPCODE
              : '',
          soAuthToken: '',
        }
      : {
          'Language-Id': process.env.VUE_APP_LANG || 'ja',
          soAuthToken: '',
        },
})

export function createAuthRequest(id, token) {
  return instance.post(
    '/app_order/auth/web/v1/',
    id
      ? {
          qrCode: id,
          checkedInAt: getLocalDateTime(new Date()),
          requestedAt: getServerDateTime(new Date()),
          reserve: [],
        }
      : {
          checkedInAt: getLocalDateTime(new Date()),
          requestedAt: getServerDateTime(new Date()),
          reserve: [],
        },
    token
      ? {
          headers: { soAuthToken: token },
        }
      : {}
  )
}

export function createAuth(id, token) {
  return retry(() => createAuthRequest(id, token), config.authRetryCount)
}

export function fetchSeat(cancelToken) {
  return instance.get('/app_order/seat/status/v1/', {
    cancelToken,
  })
}

export function fetchRecommend(shopId) {
  return instance.get(`/app_order/recommend/timer/v1/?shopId=${shopId}`)
}

export function fetchOrderRecommend(shopId, itemId) {
  return instance.get(`/app_order/recommend/order/v1/?shopId=${shopId}&itemCode=${itemId}`)
}

export function fetchShopDetail(shopId) {
  return instance.get(`/app_order/shops/v1/${shopId}`)
}

export function fetchSuggests(shopId) {
  return instance.get(`/app_order/tags/v1/${shopId}`)
}

export function fetchMenu(shopId, seatNo) {
  return instance.get(`/app_order/menus/v1/${shopId}/${seatNo}`)
}

export function fetchMenuDetail(shopId, seatNo, itemId) {
  return instance.get(`/app_order/items/v1/${shopId}/${seatNo}/${itemId}`)
}

export function orderMenu(shopId, seatNo, params) {
  return instance.post(`/app_order/add/v1/${shopId}/${seatNo}`, params)
}

export function orderMenuCancel(shopId, orderId) {
  return instance.post(`/app_order/cancel/v1/${shopId}/`, { orderId })
}

export function checkout(shopId, seatNo, status = 1) {
  return instance.post(`/app_order/pay/v1/${shopId}/${seatNo}`, {
    status,
    requestedAt: getServerDateTime(new Date()),
    reserve: [],
  })
}

export function checkoutCancel(shopId, seatNo) {
  return checkout(shopId, seatNo, 0)
}

export function callStaff(shopId, seatNo, status = 1) {
  return instance.post(`/app_order/staff/call/v1/${shopId}/${seatNo}`, {
    status,
    requestedAt: getServerDateTime(new Date()),
    reserve: [],
  })
}

export function callStaffCancel(shopId, seatNo) {
  return callStaff(shopId, seatNo, 0)
}

export function drawBikkuraponLottery(shopId, seatNo) {
  return instance.post(`/app_order/bikkurapon/lottery/v1/${shopId}/${seatNo}/`, {
    requestedAt: getServerDateTime(new Date()),
    reserve: [],
  })
}

export function playSideDeBikkuraponVideo(shopId, seatNo) {
  return instance.post(`/app_order/bikkurapon/video/v1/${shopId}/${seatNo}/`, {
    type: 3, // スマホでビッくらポン=3
    result: 1, // びっくらポン結果 はずれ:0 あたり:1 ランダム:2
    requestedAt: getServerDateTime(new Date()),
    reserve: [],
  })
}

export function enableBikkurapon(shopId, seatNo, enable) {
  return instance.post(`/app_order/bikkurapon/play/v1/${shopId}/${seatNo}`, {
    playing: enable,
    requestedAt: getServerDateTime(new Date()),
    reserve: [],
  })
}

export function playBirthdayVideo(shopId, seatNo) {
  return instance.post(`/app_order/bikkurapon/video/v1/${shopId}/${seatNo}/`, {
    type: 2,
    requestedAt: getServerDateTime(new Date()),
    reserve: [],
  })
}

export function fetchQr(shopId, seatNo) {
  return instance.get(`/app_order/qr/children/v1/${shopId}/${seatNo}`)
}

export function fetchHistory(shopId, seatNo, checkedInAt) {
  return instance.get(
    `/app_order/histories/v1/?shopId=${shopId}&seatNo=${seatNo}&checkedInAt=${checkedInAt}`
  )
}

export function fetchPastHistory(shopId) {
  return instance.get(`/app_order/histories/v1/?shopId=${shopId}`, {})
}

export function fetchPreOrderHistory(shopId) {
  return instance.get(`/app_order/histories/pre/v1/?shopId=${shopId}`, {})
}

export function deauth(shopId, seatNo) {
  return instance.post(`/app_order/deauth/oneself/v1/${shopId}/${seatNo}/`, {
    deviceId: 'aaaa',
    checkedOutAt: getLocalDateTime(new Date()),
    requestedAt: getServerDateTime(new Date()),
    reserve: [],
  })
}
